 <template>
 <div id="app">
   <component :is="layout">
     <router-view/>
  </component>
 </div>
</template>

<script>
const default_layout = 'no-sidebar'
export default {

  computed: {
    
    layout () {
      
      return (this.$route.meta.layout || default_layout) + '-layout'
     
    }
  }
 
}
</script>
<style>

 .msgWorning {
 
 text-align: center
}             
.msgSucess {
 color:green;
 text-align: center
}
.msgError {
 color:red;
 text-align: center
}
.formPosition {
  margin-top: 10px;
}

/* ----------- ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE MENÚ ----------------------- */
.menu_container_section_background {
  width: 100%;
  background-color: transparent;
  background-size: cover;
  background-position: center;
  position: relative;
}
.menu_container_section_container {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-between;
}
.menu_container_section_ {
  overflow: hidden;
  width: 97%;
  height: 60px;
  margin: 0 auto 5px;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  transition: all .5s ease-in-out;
  cursor: pointer;
  position: relative;
}
.menu_container_section_:hover {
  box-shadow: rgba(0, 0, 0, 0.50) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  font-size: 18px;
  text-decoration: underline;
}
.menu_container_section_img {
    width: 50px;
    height: 50px;
    margin-right: 3px;
}

.photo {
      width: 34px;
      height: 34px;
      overflow: hidden;
      float: left;
      z-index: 5;
      margin-right: 10px;
      border-radius: 50%;
      margin-left: 23px;
  
       
    }
.bodyLancamentoNotas{
  width:100%;
  margin-left:-60px;
}
.menu_container_section_img img {
  width: inherit;
  height: inherit;
}
.menu_container_section_text_container {
  height: 50px;
  padding: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.menu_container_section_text_title {
  font-weight: bold;
  font-size: 1.2em;
  color: #000;
}
.menu_container_section_text_sutitle {
  font-weight: bold;
  font-size: .9em;
  color: #403f3f;
}

.novo-badge-item-menu {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #0059ff;
  color: #ffffff;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  /* animation: blink 1s linear infinite; */
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

@media (min-width: 700px) {
  .menu_container_section_container {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .menu_container_section_ {
    width: 86%;
    height: 180px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
  }
  .menu_container_section_img {
    width: 90px;
    height: 90px;
    margin: 0px;
  }
}

/* ----------- FIM ESTILIZAÇÃO GLOBAL PARA AS PÁGINAS DE MENÚ ----------------------- */


/* ------------------ ESTILIZANDO O CABEÇALHO TOP ---------------------------- */
.top_info_container {
  padding: 5px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  background-color: #fff;
  align-items: center;
  justify-items: center;;
}

@media screen and (max-width: 768px) {
  .top_info_container {
    grid-template-columns: 1fr;
  }
}
/* ------------------ FIM ESTILIZANDO O CABEÇALHO TOP ---------------------------- */


/* ============= TOP SEARCH ================= */
.top_info_search_container {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}

.top_info_search_container .input_search_btn {
  background-color: yellow !important;
}
input.input_search {
  border: 1px solid #808080;
  padding: 2px;
  border-radius: 10px;
  display: block;
  width: 80%;
  margin: 10px auto;
  text-align: center;
  cursor: auto;
  outline: none;
}

input.input_search:focus {
  border: 1px solid #808080 !important;
}
/* ============= FIM TOP SEARCH ================= */


.tpaCombox {
    height: 50px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 0 5px;
}

/* ===== FUNÇÕES RELACIONADOS AO NOVO LAYOUT DAS TABELAS E COMPONENTS ================= */
.finPagContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: transparent;
}

.search-container {
  width: 40%;
  margin-bottom: 15px;
}

.search-bar {
  width: 100%;
}

.configuracoes-table {
  width: 95%;
  margin: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  color: white;
}

/** */

/* Estilo do cabeçalho */
.dialog-header {
    display: flex;
    justify-content: flex-end;
    padding: 8px;
}

/* Botão de fechar */
.close-btn {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s;
}

.close-btn:hover {
    background-color: #ffeaea;
}

/* Tabela */
.configuracoes-table {
    margin-top: 15px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Chips */
.v-chip {
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 16px;
}

.tituloPopUp {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
}

.permissoes-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 10px;
}

.permissao-item {
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f7f7f7;
}

.nivel {
    font-weight: bold;
}

.tpaCombox .v-input {
    margin-bottom: 10px;
}

</style>